// extracted by mini-css-extract-plugin
module.exports = {"block":"_16999","list":"_16871","more":"_12452","arrow":"_9893"};